import apiService from '../../../services/apiService';
import axios from 'axios';

const RETREAT_API = '/ykrestapi/CampChannel';
const CLASS_API = '/api/Class';
const PAYMENT_API = '/ykrestapi/PaymentChannel';
const COMMON_API = '/ykrestapi/CommonChannel';
const API_BASE_URL = process.env.REACT_APP_YK_API_BASE || 'http://localhost:5000/ykrestapi';

export const retreatService = {
  // ─── Centers ───────────────────────────────────────────────────────────────

  getCenters: async (countryDesc = 'USA') => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetCenterForRetreat`, {
        Country_Desc: countryDesc,
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching retreat centers:', error);
      throw error;
    }
  },

  // ─── Retreats ──────────────────────────────────────────────────────────────

  getRetreatsByCenter: async (centerId, countryDesc = 'USA') => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetCamp`, {
        Camp_Id: 0,
        Center_Id: parseInt(centerId),
        Camp_Name: '',
        Camp_Description: '',
        Camp_Fee: 0,
        Camp_Date_To: new Date().toISOString(),
        Camp_Date_From: new Date().toISOString(),
        Camp_Image_Url: '',
        Camp_Type: 'R',
        App_Id: 4,
        Organization_Id: 0,
        Country_Desc: countryDesc,
      });
      const data = Array.isArray(response.data) ? response.data : (response.data ? [response.data] : []);
      return data.filter(c => {
        const type = c.camp_Type || c.Camp_Type;
        return !type || type === 'R';
      });
    } catch (error) {
      console.error('Error fetching retreats by center:', error);
      throw error;
    }
  },

  getRetreatInfo: async (campId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetCamp`, {
        Camp_Id: parseInt(campId),
        Center_Id: 0,
        Camp_Name: '',
        Camp_Description: '',
        Camp_Fee: 0,
        Camp_Date_To: new Date().toISOString(),
        Camp_Date_From: new Date().toISOString(),
        Camp_Image_Url: '',
        Camp_Type: 'R',
        App_Id: 4,
        Organization_Id: 0,
        Country_Desc: 'USA',
      });
      const data = response.data;
      if (Array.isArray(data)) {
        return data.find((c) => (c.camp_Id || c.Camp_Id) === parseInt(campId)) || data[0] || null;
      }
      return data || null;
    } catch (error) {
      return null;
    }
  },

  // ─── Accommodation & Camp Dates ────────────────────────────────────────────

  getAccommodationAndCampDate: async (campId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetAccommodationFeeAndCampDate`, {
        Camp_Id: parseInt(campId),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching accommodation and camp date:', error);
      throw error;
    }
  },

  // ─── Attendees (Family Members) ────────────────────────────────────────────

  getUnregisteredAttendees: async (userId, campId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/FetchUnRegisteredStudents`, {
        User_Id: parseInt(userId),
        Camp_Id: parseInt(campId),
        Camp_Type: 'R',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching unregistered attendees:', error);
      throw error;
    }
  },

  getRegisteredAttendees: async (userId, campId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/FetchRegisteredStudents`, {
        User_Id: parseInt(userId),
        Camp_Id: parseInt(campId),
        Camp_Type: 'R',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching registered attendees:', error);
      throw error;
    }
  },

  addAttendee: async (userId, attendeeData) => {
    try {
      const gender = attendeeData.gender === 'Male' ? 'M' : attendeeData.gender === 'Female' ? 'F' : '';
      const dob = attendeeData.dateOfBirth
        ? new Date(attendeeData.dateOfBirth).toISOString()
        : new Date().toISOString();
      const response = await apiService.post(`${CLASS_API}/AddStudent`, {
        studentId: 0, Student_Id: 0,
        classId: 0, Class_Id: 0,
        campId: 0, Camp_Id: 0,
        enrollmentId: 0, Enrollment_Id: 0,
        userId: parseInt(userId), User_id: parseInt(userId),
        lastName: attendeeData.lastName || '', Student_Last_Name: attendeeData.lastName || '',
        firstName: attendeeData.firstName || '', Student_First_Name: attendeeData.firstName || '',
        dateOfBirth: dob, Student_Date_Of_Birth: dob, Student_Date_Of_Birth1: '',
        gender, Student_Gender: gender,
        relationship: attendeeData.relationship || '', Student_Relationship_To_User: attendeeData.relationship || '',
        Student_Age: 0, Parent_Last_Name: '', Parent_First_Name: '',
        Student_Email: '', Student_Phone: '', Student_Address_Line1: '',
        Student_Address_Line2: '', Student_City: '', Student_Country: '',
        State_Id: 0, state_Id: 0, Student_Zip_Code: 0,
        Student_Internal_Comments: '', Student_Occupation: '', Status: 'Active', status: 'Active',
        createdBy: userId.toString(), Student_Age_Group_Id: 0, Is_Accommodation_Needed: '',
        Seva_Opportunity_Id: 0, RegisterSession_Count: 0, Selected_Session_Count: 0,
        Selected_To_Pay_Amt: 0, Extended_Amt: 0, Registered_Session_Count: 0,
        Registered_To_Pay_Amt: 0, User_Email: '', user_Email: '',
      });
      return response.data;
    } catch (error) {
      console.error('Error adding attendee:', error);
      throw error;
    }
  },

  updateAttendee: async (userId, attendeeId, attendeeData) => {
    try {
      const gender = attendeeData.gender === 'Male' ? 'M' : attendeeData.gender === 'Female' ? 'F' : '';
      const dob = attendeeData.dateOfBirth
        ? new Date(attendeeData.dateOfBirth).toISOString()
        : new Date().toISOString();
      const response = await apiService.post(`${CLASS_API}/UpdateStudent`, {
        studentId: parseInt(attendeeId), Student_Id: parseInt(attendeeId),
        classId: 0, Class_Id: 0,
        campId: 0, Camp_Id: 0,
        enrollmentId: 0, Enrollment_Id: 0,
        userId: parseInt(userId), User_id: parseInt(userId),
        lastName: attendeeData.lastName || '', Student_Last_Name: attendeeData.lastName || '',
        firstName: attendeeData.firstName || '', Student_First_Name: attendeeData.firstName || '',
        dateOfBirth: dob, Student_Date_Of_Birth: dob, Student_Date_Of_Birth1: '',
        gender, Student_Gender: gender,
        relationship: attendeeData.relationship || '', Student_Relationship_To_User: attendeeData.relationship || '',
        Student_Age: 0, Parent_Last_Name: '', Parent_First_Name: '',
        Student_Email: '', Student_Phone: '', Student_Address_Line1: '',
        Student_Address_Line2: '', Student_City: '', Student_Country: '',
        State_Id: 0, state_Id: 0, Student_Zip_Code: 0,
        Student_Internal_Comments: '', Student_Occupation: '', Status: 'Active', status: 'Active',
        createdBy: userId.toString(), Student_Age_Group_Id: 0, Is_Accommodation_Needed: '',
        Seva_Opportunity_Id: 0, RegisterSession_Count: 0, Selected_Session_Count: 0,
        Selected_To_Pay_Amt: 0, Extended_Amt: 0, Registered_Session_Count: 0,
        Registered_To_Pay_Amt: 0, User_Email: '', user_Email: '',
      });
      return response.data;
    } catch (error) {
      console.error('Error updating attendee:', error);
      throw error;
    }
  },

  // ─── Registration ──────────────────────────────────────────────────────────

  addRegistration: async (userId, campId, attendeeId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/AddRetreatRegistration`, {
        Retreat_Registration_Id: 0,
        Student_Id: parseInt(attendeeId),
        Camp_Id: parseInt(campId),
        User_Id: parseInt(userId),
        Status: 'Active',
        Isactive: 'Y',
        CreatedBy: userId.toString(),
        Created: new Date().toISOString(),
        ModifiedBy: userId.toString(),
        Modified: new Date().toISOString(),
      });
      return response.data;
    } catch (error) {
      console.error('Error adding retreat registration:', error);
      throw error;
    }
  },

  addRegistrationDetail: async (registrationId, campId, attendeeId, detailData, userId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/AddRetreatRegistrationDetail`, {
        Retreat_Registration_Details_Id: 0,
        Retreat_Registration_Id: parseInt(registrationId),
        Student_Id: parseInt(attendeeId),
        Camp_Id: parseInt(campId),
        Start_Date: detailData.startDate,
        End_Date: detailData.endDate,
        No_Of_Days: detailData.noOfDays || 1,
        Is_Accommodation_Needed: detailData.isAccommodationNeeded || 'N',
        Is_Transport: detailData.isTransport || 'N',
        Registration_Fee: detailData.registrationFee || 0,
        Accommodation_Fees: detailData.accommodationFees || 0,
        Visits: String(detailData.visits || '1'),
        Registration_Completed: 0,
        Isactive: 'Y',
        CreatedBy: userId ? userId.toString() : '',
        ModifiedBy: userId ? userId.toString() : '',
        Created: new Date().toISOString(),
        Modified: new Date().toISOString(),
      });
      return response.data;
    } catch (error) {
      console.error('Error adding retreat registration detail:', error);
      throw error;
    }
  },

  deleteRegistrationDetail: async (campId, attendeeId, detailId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/DeleteRecordOfvisiters`, {
        Camp_Id: parseInt(campId),
        Student_Id: parseInt(attendeeId),
        Retreat_Registration_Details_Id: parseInt(detailId),
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting registration detail:', error);
      throw error;
    }
  },

  getRegistrationRecords: async (campId, attendeeId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/VisitRegisteredStudent`, {
        Camp_Id: parseInt(campId),
        Student_Id: parseInt(attendeeId),
        Camp_Type: 'R',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching registration records:', error);
      throw error;
    }
  },

  // ─── Calculation ───────────────────────────────────────────────────────────

  getCalculation: async (userId, campId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetRetreatCalculation`, {
        User_Id: parseInt(userId),
        Camp_Id: parseInt(campId),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching retreat calculation:', error);
      throw error;
    }
  },

  // ─── Sessions ──────────────────────────────────────────────────────────────

  getCampSessions: async (campId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/GetCampSessions`, {
        Camp_Id: parseInt(campId),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching retreat sessions:', error);
      return [];
    }
  },

  // ─── Session records ────────────────────────────────────────────────────────

  getSessionRecords: async (campId, attendeeId) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/VisitRegisteredStudent`, {
        Camp_Id: parseInt(campId),
        Student_Id: parseInt(attendeeId),
        Camp_Type: 'R',
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching session records:', error);
      throw error;
    }
  },

  // ─── Payment ───────────────────────────────────────────────────────────────

  updatePaymentStatus: async (paymentData) => {
    try {
      const response = await apiService.post(`${RETREAT_API}/UpdatePaymentStatus`, paymentData);
      return response.data;
    } catch (error) {
      console.error('Error updating payment status:', error);
      throw error;
    }
  },

  createOrder: async ({ userId, campId, totalAmount, feeAmount, discountAmount, donationAmount, accommodationAmount, otherDonation, paymentMethod }) => {
    try {
      const now = new Date().toISOString();
      const response = await apiService.post(`${RETREAT_API}/CreateCampOrder`, {
        User_Id: parseInt(userId),
        Camp_Id: parseInt(campId),
        Camp_Order_Date: now,
        Camp_Order_Time: now,
        Camp_Total_Gross_Amt: parseFloat(totalAmount) || 0,
        Camp_Discount_Amt: parseFloat(discountAmount) || 0,
        Camp_Net_Amt: parseFloat(totalAmount) || 0,
        Camp_Fee_Amt: parseFloat(feeAmount || totalAmount) || 0,
        Camp_Donation_Amt: parseFloat(donationAmount) || 0,
        Camp_Accommodation_Amt: parseFloat(accommodationAmount) || 0,
        Camp_Other_Donation: otherDonation || 'NA',
        Camp_Order_Status: 'Pending',
        Payment_Method: paymentMethod || 'Paysimple',
        CreatedBy: userId.toString(),
        Created: now,
        ModifiedBy: userId.toString(),
        Modified: now,
      });
      return response.data;
    } catch (error) {
      console.error('Error creating retreat order:', error);
      throw error;
    }
  },

  processPayment: async (paymentDetails) => {
    try {
      const isACH = paymentDetails.paymentType === 'ACH';
      const payload = {
        app: 'Camp',
        entity: paymentDetails.entity || 'RMS',
        paymentType: isACH ? 'ach' : 'cc',
        customerEmail: paymentDetails.userEmail,
        orderid: paymentDetails.campId?.toString() || '0',
        amount: paymentDetails.amount?.toString() || '0',
        description: `Retreat Registration - ${paymentDetails.campName || ''} - $${paymentDetails.amount}`,
        customer: {
          firstName: paymentDetails.userFirstName || '',
          lastName: paymentDetails.userLastName || '',
          email: paymentDetails.userEmail,
          phone: paymentDetails.userPhone || '',
          company: 'string',
          notes: `Retreat registration for ${paymentDetails.userFirstName} ${paymentDetails.userLastName}`,
          customerAccount: paymentDetails.userId?.toString() || 'string',
          shippingSameAsBilling: true,
          billingAddress: {
            streetAddress1: paymentDetails.streetAddress1 || '-',
            streetAddress2: paymentDetails.streetAddress2 || '-',
            city: paymentDetails.city || '-',
            stateCode: paymentDetails.state || '-',
            zipCode: paymentDetails.zipCode || '-',
            country: paymentDetails.country || 'USA',
          },
          shippingAddress: {
            streetAddress1: paymentDetails.streetAddress1 || '-',
            streetAddress2: paymentDetails.streetAddress2 || '-',
            city: paymentDetails.city || '-',
            stateCode: paymentDetails.state || '-',
            zipCode: paymentDetails.zipCode || '-',
            country: paymentDetails.country || 'USA',
          },
        },
        creditcard: isACH
          ? { creditCardNumber: 'string', expirationDate: 'string', issuer: 'string', billingZipCode: 'string', customerId: '', cvv: 'string' }
          : {
              creditCardNumber: (paymentDetails.cardNumber || '').replace(/\s/g, ''),
              expirationDate: paymentDetails.expiryDate,
              issuer: 'string',
              billingZipCode: paymentDetails.zipCode || '-',
              customerId: '',
              cvv: paymentDetails.cvv,
            },
        ach: isACH
          ? {
              isCheckingAccount: paymentDetails.accountType === 'checking' ? 'Y' : 'N',
              routingNumber: paymentDetails.routingNumber,
              accountNumber: paymentDetails.accountNumber,
              bankName: paymentDetails.bankName || 'Financial Institution',
              customerId: '',
              isDefault: 'false',
            }
          : { isCheckingAccount: 'string', routingNumber: 'string', accountNumber: 'string', bankName: 'string', customerId: 'string', isDefault: 'string' },
        recurr: {
          paymentAmount: 'string', accountId: 'string', startDate: 'string',
          executionFrequencyType: 'string', executionFrequencyParameter: 'string',
          endDate: 'string', paymentSubType: 'string', invoiceNumber: 'string',
          firstPaymentAmount: 'string', firstPaymentDate: 'string', description: 'string',
        },
      };
      const response = await axios.post(
        `${API_BASE_URL}${PAYMENT_API.replace('/ykrestapi', '')}/AuthNetOneTimePayment`,
        payload,
        { headers: { 'Content-Type': 'application/json' }, timeout: 60000 }
      );
      return response.data;
    } catch (error) {
      console.error('Retreat payment processing error:', error?.response?.data || error);
      throw error;
    }
  },

  sendConfirmationEmail: async (emailData) => {
    try {
      const studentsList =
        emailData.students && emailData.students.length > 0
          ? emailData.students
              .map((s) => {
                if (s.studentName) return s.studentName;
                const fn = s.student_First_Name || s.firstName || '';
                const ln = s.student_Last_Name || s.lastName || '';
                return `${fn} ${ln}`.trim();
              })
              .filter(Boolean)
              .join(', ')
          : emailData.studentName || 'N/A';

      const buildScheduleTable = () => {
        const entries = emailData.students && emailData.students.length > 0 ? emailData.students : null;
        if (!entries) return emailData.scheduleHtml || studentsList;
        const thStyle = 'padding:10px 14px;text-align:left;background-color:#eeeeee;color:#111827;font-family:Helvetica,Arial,sans-serif;font-size:12px;border:1px solid #d0d0d0;';
        const tdStyle = 'padding:9px 14px;border:1px solid #e0e0e0;font-family:Helvetica,Arial,sans-serif;font-size:13px;color:#374151;vertical-align:top;';
        const tdAltStyle = 'padding:9px 14px;border:1px solid #e0e0e0;font-family:Helvetica,Arial,sans-serif;font-size:13px;color:#374151;background-color:#f7f7f7;vertical-align:top;';
        let rows = '';
        let rowIdx = 0;
        for (const entry of entries) {
          const name = entry.studentName || '';
          const sessions = entry.selectedWeeksData || [];
          const extNums = new Set(entry.extendedWeekNumbers || []);
          for (const w of sessions) {
            const isAlt = rowIdx % 2 !== 0;
            const td = isAlt ? tdAltStyle : tdStyle;
            const bg = isAlt ? ' bgcolor="#f7f7f7"' : '';
            const extCell = extNums.has(w.weekNumber)
              ? `<span style="color:#b45309;">&#10003; Accommodation</span>`
              : `<span style="color:#6b7280;">&#8212;</span>`;
            rows += `<tr>
              <td${bg} style="${td}">${name}</td>
              <td${bg} style="${td}">Session ${w.weekNumber}</td>
              <td${bg} style="${td}">${w.dateRange || ''}</td>
              <td${bg} style="${td}">${extCell}</td>
            </tr>`;
            rowIdx++;
          }
        }
        return `<table width="100%" cellpadding="0" cellspacing="0" border="0" style="border-collapse:collapse;">
          <tr>
            <td bgcolor="#eeeeee" style="${thStyle}">Attendee</td>
            <td bgcolor="#eeeeee" style="${thStyle}">Session</td>
            <td bgcolor="#eeeeee" style="${thStyle}">Dates</td>
            <td bgcolor="#eeeeee" style="${thStyle}">Accommodation</td>
          </tr>
          ${rows}
        </table>`;
      };
      const scheduleHtml = buildScheduleTable();

      const fullName = (emailData.userFirstName || emailData.userLastName)
        ? `${emailData.userFirstName || ''} ${emailData.userLastName || ''}`.trim()
        : (emailData.userName || '').trim() || 'Devotee';

      const emailParameter = {
        emailFrom: 'string',
        emailTo: emailData.toEmail || 'string',
        emailSubject: 'string',
        emailBody: 'string',
        attachment: 'Y',
        userPhoneNumber: emailData.userPhone ? `1${(emailData.userPhone || '').replace(/\D/g, '')}` : 'string',
        location: 'RetreatRegistration',
        input: 'string',
        appContent: {
          userName: fullName,
          programName: emailData.retreatName || emailData.campName || 'string',
          appSchedule: scheduleHtml,
          attendee: studentsList,
          date: emailData.transactionDate || new Date().toLocaleString(),
          orderType: 'Retreat Registration',
          orderNo: String(emailData.registrationId || 'string'),
          paymentMode: emailData.paymentType || 'CC',
          amount: String(emailData.amount || '0'),
          email: emailData.toEmail || 'string',
          phone: emailData.userPhone || 'N/A',
          pickupPerson: emailData.studentName || studentsList,
          pickupPersonContact: 'string',
          instructions: emailData.sessionsLabel || 'N/A',
          itemData: scheduleHtml || studentsList,
          pickUpDate: emailData.retreatDateRange || emailData.campDateRange || 'N/A',
          pickUpTime: 'string',
          paymentType: emailData.paymentType || 'CC',
          billingAddress: emailData.billingAddress || 'N/A',
          address: emailData.billingAddress || 'N/A',
          pickupOrReceiver: 'string',
          orderReady: String(emailData.amount || '0'),
          orderReadyLastLine: 'string',
          headingDate: emailData.retreatDateRange || emailData.campDateRange || new Date().toLocaleDateString(),
          headingTime: 'string',
        },
      };

      const response = await axios.post(
        `${API_BASE_URL}/MessageChannel/SendEmailMessage?appName=Retreat&templateName=RetreatRegistrationConfirmation&orgId=3`,
        emailParameter,
        { timeout: 30000 }
      );
      return response.data;
    } catch (error) {
      console.error('Retreat email error:', error?.response?.data || error);
      throw error;
    }
  },

  sendAdminAlertEmail: async ({ stepStatus, transactionId, retreatName, campId, userId, userName, userEmail, totalAmount, paymentMethod, timestamp, errorDetails }) => {
    const adminEmail = process.env.REACT_APP_CAMP_ADMIN_EMAIL || 'campregistration@yugalkunj.org';
    const steps = stepStatus || {};
    const hasFailure = Object.values(steps).some((s) => !s.success);

    const stepRows = Object.entries(steps).map(([key, val]) => {
      const icon = val.success ? '✅' : '❌';
      const color = val.success ? '#16a34a' : '#dc2626';
      return `<tr><td style="padding:6px 12px;border-bottom:1px solid #f3f4f6;">${icon} <strong>${key}</strong></td><td style="padding:6px 12px;border-bottom:1px solid #f3f4f6;color:${color};">${val.message || (val.success ? 'Success' : 'Failed')}</td>${val.error ? `<td style="padding:6px 12px;border-bottom:1px solid #f3f4f6;color:#b91c1c;font-size:12px;">${val.error}</td>` : '<td></td>'}</tr>`;
    }).join('');

    const htmlBody = `
<div style="font-family:Arial,sans-serif;max-width:600px;margin:0 auto;border:1px solid #e5e7eb;border-radius:12px;overflow:hidden;">
  <div style="background:${hasFailure ? '#dc2626' : '#16a34a'};padding:20px 24px;">
    <h2 style="color:#fff;margin:0;">${hasFailure ? '⚠️ Retreat Registration Alert' : '✅ Retreat Registration Complete'}</h2>
    <p style="color:rgba(255,255,255,0.85);margin:4px 0 0;">${timestamp}</p>
  </div>
  <div style="padding:24px;">
    <table style="width:100%;border-collapse:collapse;margin-bottom:20px;">
      <tr><td style="padding:4px 0;color:#6b7280;width:140px;">Retreat</td><td style="font-weight:600;">${retreatName} (ID: ${campId})</td></tr>
      <tr><td style="padding:4px 0;color:#6b7280;">User</td><td style="font-weight:600;">${userName} (ID: ${userId})</td></tr>
      <tr><td style="padding:4px 0;color:#6b7280;">Email</td><td>${userEmail}</td></tr>
      <tr><td style="padding:4px 0;color:#6b7280;">Amount</td><td style="font-weight:600;color:#16a34a;">$${parseFloat(totalAmount || 0).toFixed(2)}</td></tr>
      <tr><td style="padding:4px 0;color:#6b7280;">Method</td><td>${paymentMethod || 'N/A'}</td></tr>
      ${transactionId ? `<tr><td style="padding:4px 0;color:#6b7280;">Transaction ID</td><td style="font-family:monospace;font-weight:600;">${transactionId}</td></tr>` : ''}
    </table>
    <h3 style="margin:0 0 8px;font-size:14px;color:#374151;">Step-by-Step Results</h3>
    <table style="width:100%;border-collapse:collapse;font-size:13px;">
      <thead><tr style="background:#f9fafb;"><th style="padding:6px 12px;text-align:left;">Step</th><th style="padding:6px 12px;text-align:left;">Status</th><th style="padding:6px 12px;text-align:left;">Error Detail</th></tr></thead>
      <tbody>${stepRows}</tbody>
    </table>
    ${errorDetails ? `<div style="margin-top:16px;padding:12px;background:#fef2f2;border-left:4px solid #dc2626;border-radius:6px;font-size:12px;color:#b91c1c;"><strong>Full Error:</strong><br/><pre style="margin:4px 0 0;white-space:pre-wrap;">${String(errorDetails).substring(0, 1000)}</pre></div>` : ''}
    <p style="margin-top:20px;font-size:12px;color:#9ca3af;">This is an automated alert from the YugalKunj Retreat Portal.</p>
  </div>
</div>`;

    try {
      await axios.post(
        `${API_BASE_URL}/MessageChannel/SendEmailMessage?appName=Retreat&templateName=RetreatRegistrationConfirmation&orgId=3`,
        {
          emailFrom: 'string',
          emailTo: adminEmail,
          emailSubject: 'string',
          emailBody: htmlBody,
          attachment: 'N',
          userPhoneNumber: 'string',
          location: 'RetreatAdminAlert',
          input: 'string',
          appContent: {
            userName: 'Retreat Admin',
            programName: retreatName || 'string',
            appSchedule: htmlBody,
            attendee: userName || 'string',
            date: timestamp || new Date().toLocaleString(),
            orderType: hasFailure ? 'Alert' : 'Confirmation',
            orderNo: transactionId || 'string',
            paymentMode: paymentMethod || 'string',
            amount: String(totalAmount || '0'),
            email: adminEmail,
            phone: 'string',
            pickupPerson: 'string',
            pickupPersonContact: 'string',
            instructions: 'string',
            itemData: htmlBody,
            pickUpDate: 'string',
            pickUpTime: 'string',
            paymentType: paymentMethod || 'string',
            billingAddress: 'string',
            address: 'string',
            pickupOrReceiver: 'string',
            orderReady: 'string',
            orderReadyLastLine: 'string',
            headingDate: timestamp || 'string',
            headingTime: 'string',
          },
        },
        { timeout: 15000 }
      );
    } catch (err) {
      console.warn('Retreat admin alert email failed (non-blocking):', err);
    }
  },

  getBankName: async (routingNumber) => {
    try {
      const response = await fetch(
        `${API_BASE_URL}${COMMON_API.replace('/ykrestapi', '')}/GetBankNameByRoutingNumber?routingNumber=${routingNumber}`,
        { method: 'GET', headers: { Accept: 'application/json' } }
      );
      if (response.ok) {
        const data = await response.json();
        return data.bankName || data.name || data.institutionName || '';
      }
      return '';
    } catch (error) {
      console.error('Bank name lookup error:', error);
      return '';
    }
  },
};

export default retreatService;

